var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.001 512.001",
    height: 512,
    viewBox: "0 0 512.001 512.001",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#7B1FFE",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 30.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.25 256c0 59.414 48.336 107.75 107.75 107.75s107.75-48.336 107.75-107.75-48.336-107.75-107.75-107.75-107.75 48.337-107.75 107.75zm167.938 0c0 33.188-27 60.188-60.188 60.188s-60.188-27-60.188-60.188 27-60.188 60.188-60.188 60.188 27.001 60.188 60.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.327 246.11c-1.127-1.285-28.098-31.819-71.77-62.618-45.256-31.916-91.874-52.168-136.807-59.685 57.15 16.78 99.001 69.687 99.001 132.193s-41.851 115.413-99.001 132.193c44.933-7.516 91.551-27.769 136.807-59.685 43.671-30.798 70.643-61.333 71.77-62.618l8.674-9.891z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.25 256c0-62.506 41.851-115.413 99.001-132.193-44.933 7.516-91.551 27.769-136.807 59.685-43.671 30.798-70.643 61.333-71.77 62.618l-8.674 9.89 8.674 9.891c1.127 1.285 28.098 31.819 71.77 62.618 45.256 31.916 91.874 52.168 136.807 59.685-57.149-16.781-99.001-69.688-99.001-132.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 15h30v60.25h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.626 34.572h30v60.25h-30z",
    transform: "matrix(.707 -.707 .707 .707 2.763 136.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.25 49.698h60.25v30h-60.25z",
    transform: "matrix(.707 -.707 .707 .707 55.703 263.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241 436.75h30v60.25h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.376 417.178h30v60.25h-30z",
    transform: "matrix(.707 -.707 .707 .707 -214.841 375.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 432.304h60.25v30h-60.25z",
    transform: "matrix(.707 -.707 .707 .707 -267.781 248.127)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.0b6eacd4922aaa14fa79d1e61ffd0f99.svg";
export { ForwardRef as ReactComponent };